<script setup lang="ts">
export interface TcAppProps {
  fullscreen?: boolean;
}

const props = defineProps<TcAppProps>();
</script>

<template>
  <div
    id="container"
    class="app"
    :class="{
      'app--fullscreen': props.fullscreen,
    }"
  >
    <slot />
  </div>
</template>

<style scoped lang="scss">
.app {
  flex: 1 1 auto;
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  height: 100%;
  position: relative;

  a {
    cursor: pointer;
  }

  @media (max-width: $breakpoint-m) {
    height: calc(100% - $size-navigation-height-mobile);
    max-height: calc(100% - $size-navigation-height-mobile);
  }

  &--fullscreen {
    height: 100% !important;
    max-height: 100% !important;
  }
}

// Firefox overrides
@-moz-document url-prefix() {
  @media print {
    .app {
      display: block;
    }
  }
}
</style>
